// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
var blockGap = '0.5rem';
var iconGap = '0.5rem';
var titleFontWeight = '500';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var connectButtonStyles = css({
  justifyContent: 'flex-end',
  marginTop: blockGap
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var titleBlockStyles = css({
  gap: "".concat(blockGap, " ").concat(iconGap),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  a: {
    fontWeight: titleFontWeight
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var mainTextStyles = css({
  marginTop: blockGap,
  fontSize: '0.75rem'
});